// API Configuration
export const API_CONFIG = {
  // Base URL for API calls
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  
  // API endpoints
  ENDPOINTS: {
    // Auth endpoints
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
    
    // Database endpoints
    DATABASE_OVERVIEW: '/api/database/overview',
    DATABASE_INSTANCES: '/api/database/instances',
    
    // PostgreSQL endpoints
    POSTGRESQL_PROCESSES: '/api/postgresql/processes',
    POSTGRESQL_DATABASES: '/api/postgresql/databases',
    POSTGRESQL_USERS: '/api/postgresql/users',
    POSTGRESQL_TERMINATE_PROCESS: '/api/postgresql/processes/terminate',
    POSTGRESQL_CANCEL_PROCESS: '/api/postgresql/processes/cancel',
    POSTGRESQL_TEST_CONNECTION: '/api/postgresql/test-connection',
    
    // Kubernetes endpoints
    KUBERNETES_CLUSTERS: '/api/teleport-k8s/clusters',
    KUBERNETES_OVERVIEW: '/api/kubernetes/clusters/overview',
    KUBERNETES_PODS: '/api/kubernetes/pods',
    KUBERNETES_NAMESPACES: '/api/kubernetes/namespaces',
    KUBERNETES_SESSIONS: '/api/teleport-k8s/sessions',
    KUBERNETES_EVENTS: '/api/teleport-k8s/events',
    KUBERNETES_NODES: '/api/kubernetes/nodes',
    KUBERNETES_USERS: '/api/teleport-k8s/users',
    
    // Alerts endpoints
    ALERTS: '/api/alerts/',
    ALERTS_STATS: '/api/alerts/stats',
    ALERTS_TEST_EMAIL: '/api/alerts/test-email',
    ALERTS_MARK_READ: '/api/alerts',
    
    // Admin endpoints
    ADMIN_USERS: '/api/admin/users',
    ADMIN_USER_TOGGLE: '/api/admin/users',
    ADMIN_USER_RESET_PASSWORD: '/api/admin/users',
  }
};

// Helper function to build full API URL
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get API base URL
export const getApiBaseUrl = (): string => {
  return API_CONFIG.BASE_URL;
};

// Environment info
export const ENV_INFO = {
  NODE_ENV: process.env.NODE_ENV,
  API_BASE_URL: API_CONFIG.BASE_URL,
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
};
